import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { formatBytes, formatPageList } from './pdfSplitterGroups';

const PdfSplitterFooter = ({
  footerDocs,
  segmentResults,
  isComputing,
  oversizedSegments,
  hasUnsplittableOversize,
  maxSliceBytes,
  isExistingDocMode,
  deleteSourceAfter,
  onDeleteSourceAfterChange,
  onToggleGroupInclusion,
}) => (
  <div className="pdf-splitter-footer">
    <div className="pdf-splitter-segments-summary">
      {footerDocs.map(({ colorIndex, group, includedPages, isEmpty, docNumber }) => {
        const key = `group-${group[0]}-${group[group.length - 1]}`;
        const result = isEmpty ? null : segmentResults.find((r) => r.key === includedPages.join(','));
        const oversize = result && result.size > maxSliceBytes;
        const allIncluded = !isEmpty && includedPages.length === group.length;
        const partial = !isEmpty && !allIncluded;
        return (
          <span
            key={key}
            className={`pdf-splitter-seg-chip ${isEmpty ? 'pdf-splitter-seg-chip-empty' : `pdf-splitter-seg-${colorIndex % 6}`} ${oversize ? 'pdf-splitter-seg-chip-oversize' : ''}`}
          >
            <input
              type="checkbox"
              className="config-setting-checkbox pdf-splitter-chip-checkbox"
              checked={allIncluded}
              ref={(el) => { if (el) el.indeterminate = partial; }}
              onChange={() => onToggleGroupInclusion(group)}
              title={allIncluded ? 'Discard this document' : 'Include this document'}
            />
            {isEmpty ? (
              <span className="pdf-splitter-seg-chip-text">
                <strong>Discarded</strong> · {`Page${group.length > 1 ? 's' : ''} ${formatPageList(group)}`}
              </span>
            ) : (
              <span className="pdf-splitter-seg-chip-text">
                <strong>Doc {docNumber}</strong> · {`Page${includedPages.length > 1 ? 's' : ''} ${formatPageList(includedPages)}`}
                {result ? ` · ${formatBytes(result.size)}` : (isComputing ? ' · …' : '')}
              </span>
            )}
            {oversize && <FontAwesomeIcon icon={faExclamationTriangle} />}
          </span>
        );
      })}
    </div>

    {oversizedSegments.length > 0 && (
      <div className="pdf-splitter-warning">
        <FontAwesomeIcon icon={faExclamationTriangle} />
        {hasUnsplittableOversize
          ? ` One or more single pages are larger than ${formatBytes(maxSliceBytes)} on their own and cannot be uploaded.`
          : ` Some documents exceed the ${formatBytes(maxSliceBytes)} limit. Add more splits to make them smaller.`}
      </div>
    )}

    {isExistingDocMode && (
      <label className="pdf-splitter-delete-source">
        <input
          type="checkbox"
          checked={deleteSourceAfter}
          onChange={(event) => onDeleteSourceAfterChange(event.target.checked)}
        />
        <span>Delete the original document once the new documents have uploaded</span>
      </label>
    )}
  </div>
);

export default PdfSplitterFooter;
